export default __webpack_public_path__ + "static/anuPrasad-770d0a84092480681acd4d440d2923a2.jpg";